import { useSelector } from 'react-redux';
import { DialogSize } from '../../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultVCycleElementContainerResource,
    useVCycleElementContainerActions,
    VCycleElementContainerMutationResourceSchema,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementContainerResource';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../util/useSelectorFunctions';
import { VCycleElementContainerContent } from './VCycleElementContainerContent';

export const VCycleElementContainerEditDialog = ({
    onClose,
    objectId,
    versionedInId,
    projectId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
    projectId: string | undefined | null;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const vcycleElementContainerActions = useVCycleElementContainerActions();
    const vcycleElementContainerQuery = vcycleElementContainerActions.useGetResourceByObjectIdAndVersionedIn(
        objectId,
        versionedInId
    );
    const updateVcycleElement = vcycleElementContainerActions.useUpdateResource();
    const validation = vcycleElementContainerActions.useValidateResource(
        vcycleElementContainerQuery.data?.id,
        validationScope
    );

    const { form, formNames, onSubmit } = useMyForm({
        schema: VCycleElementContainerMutationResourceSchema,
        defaultValues: defaultVCycleElementContainerResource,
        submitHandler: async (data) => {
            await updateVcycleElement.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: vcycleElementContainerQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit V-Cycle Element Container'}
            resourceType={ResourceType.V_CYCLE_ELEMENT_CONTAINER}
            resourceValidationResult={validation.data}
            metaDataInfo={vcycleElementContainerQuery.data}
            dialogSize={DialogSize.MEDIUM_LARGE}
        >
            <QueryBaseComponent name="VcycleElement" query={vcycleElementContainerQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <VCycleElementContainerContent
                        projectId={projectId}
                        projectVersionId={versionedInId}
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={vcycleElementContainerQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
